import './styles/main.scss'
import SiteSlider from './scripts/SiteSlider'
import JacpotSlider from './scripts/JacpotSlider'
import MobileMenu from './scripts/MobileMenu'

const swiperslider = new SiteSlider()
const jackpotslider = new JacpotSlider()
const mobileMenu = new MobileMenu()
